export enum GameType {
  Cryptic = "cryptic",
  MiniSudoku = "miniSudoku",
  Quick = "quick",
  WordSearch = "wordSearch",
}
